import { BoxContainer, TextField } from '@components/common';
import css from './index.module.scss';
import { Controller, useFormContext } from 'react-hook-form';
import { IconNode } from '@components/base';
import Images from '@assets/images';

const Instructions = () => {
  const { control } = useFormContext();
  return (
    <BoxContainer className={css.mainWrapper} title="Instructions">
      <div className={css.boxWrapper}>
        <div className={css.rowWrapper}>
          <Controller
            name="instructions.emergencyContact"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Emergency Contact"
                placeholder="Emergency Contact"
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="instructions.originInstructions"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Origin Instructions"
                placeholder="Origin Instructions"
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
        </div>
        <div className={css.rowWrapper}>
          <Controller
            name="instructions.destinationInstructions"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Destination Instructions"
                placeholder="Destination Instructions"
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="instructions.originAccessorials"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Origin Accessorials"
                placeholder="Origin Accessorials"
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
        </div>
        <div className={css.rowWrapper}>
          <Controller
            name="instructions.destinationAccessorials"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Destination Accessorials"
                placeholder="Destination Accessorials"
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
          <Controller
            name="instructions.special"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Special Instructions"
                placeholder="Special Instructions"
                error={fieldState.invalid}
                endIcon={
                  fieldState.invalid && <IconNode src={Images.alertError} alt="Error Icon" />
                }
                helperText={fieldState.error?.message}
              />
            )}
          />
        </div>
      </div>
    </BoxContainer>
  );
};

export default Instructions;
